<div class="parceiros">
    <!-- Blog e FAQ -->
    <ng-template #blogAndFaqSections>
        <!-- blog posts -->
        <section class="blog-section" *ngIf="blogSection?.cards?.length" [style.background-color]="blogSection.backgroundColor || '#ffffff'">
            <div class="wrapper-container">
                <h2 class="blog-section__title">
                    {{ blogSection.title }}
                </h2>
                <h3 class="blog-section__subtitle">
                    {{ blogSection.subtitle }}
                </h3>

                <div class="blog-cards">
                    <article class="blog-card" *ngFor="let card of blogSection.cards">
                        <a
                            *ngIf="card.link"
                            class="blog-card__image-link"
                            [href]="card.link"
                            target="_blank"
                            rel="noopener noreferrer"
                            [attr.aria-label]="'Ler artigo: ' + card.label"
                        >
                            <img
                                class="blog-card__image"
                                [src]="card.image"
                                [alt]="card.text"
                                loading="lazy"
                            >
                        </a>

                        <img
                            *ngIf="!card.link"
                            class="blog-card__image"
                            [src]="card.image"
                            [alt]="card.text"
                            loading="lazy"
                        >

                        <div class="blog-card__content">
                            <span class="blog-card__label">
                                {{ card.label }}
                            </span>

                            <h3 class="blog-card__text">
                                {{ card.text }}
                            </h3>

                            <a
                                *ngIf="card.link"
                                class="blog-card__link"
                                [href]="card.link"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                            <svg
                                class="blog-card__arrow"
                                width="24"
                                height="11"
                                viewBox="0 0 24 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                            >
                                <path
                                    d="M1 5.5L22.8694 5.5M18.6758 10L23 5.5L18.6758 1"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                                Ler artigo completo
                            </a>
                        </div>
                    </article>
                </div>
            </div>
        </section>
        <!-- end blog posts -->

        <!-- FAQ -->
        <section
            class="faq-section"
            *ngIf="faqSection?.items?.length"
            [style.background-color]="faqSection.backgroundColor || '#DFEFF2'"
        >
            <div class="wrapper-container faq-section__container">
                <h2 class="faq-section__title">
                    {{ faqSection.title }}
                </h2>

                <p class="faq-section__subtitle">
                    {{ faqSection.subtitle }}
                </p>

                <div class="faq-list">
                    <article
                        class="faq-item"
                        *ngFor="let item of faqSection.items; let i = index"
                        [class.faq-item--active]="activeFaqIndex === i"
                    >
                        <button
                            type="button"
                            class="faq-item__button"
                            (click)="toggleFaq(i)"
                            [attr.aria-expanded]="activeFaqIndex === i"
                            [attr.aria-controls]="'faq-answer-' + i"
                            [style.background-color]="faqSection.questionBackgroundColor || '#FFFFFF'"
                        >
                            <span>{{ item.question }}</span>

                            <svg
                                class="faq-item__arrow"
                                width="18"
                                height="10"
                                viewBox="0 0 18 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                            >
                                <path
                                    d="M1 1L9 9L17 1"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </button>

                        <div
                            *ngIf="activeFaqIndex === i"
                            class="faq-item__answer"
                            [id]="'faq-answer-' + i"
                        >
                            <p>{{ item.answer }}</p>
                        </div>
                    </article>
                </div>
            </div>
        </section>
        <!-- end FAQ -->
    </ng-template>
<!--    <div *ngIf="slug === '/'" class="toggle-safes">-->
<!--        <ngx-slick-carousel class="carousel my-carousel" #slickModal="slick-carousel" [config]="slideConfig">-->
<!--            <div ngxSlickItem class="slide">-->
<!--                <div class="know-more-content is-other">-->
<!--                    <div class="know-more-wrapper">-->
<!--                        <div class='text-area'>-->
<!--                            <div class="text-title">-->
<!--                                <p>-->
<!--                                    <span style="color:#003781">Seja um </span>-->
<!--                                    <strong>-->
<!--                                        <span style="color:#f62459">segurado Allianz</span>-->
<!--                                    </strong>-->
<!--                                    <span style="color:#003781"> e esteja sempre pronto para </span>-->
<!--                                    <span style="color:#f62459">-->
<!--                                        <strong>viver o melhor</strong>!-->
<!--                                    </span>-->
<!--                                </p>-->
<!--                            </div>-->

<!--                            <div class="text-description">-->
<!--                                <p>-->
<!--                                    <span style="color:#003781">-->
<!--                                        Cuidamos de você, da sua família e das suas conquistas. Com a Allianz você fica tranquilo para curtir a vida sabendo que seus bens e quem você ama estão protegidos.-->
<!--                                    </span>-->
<!--                                </p>-->

<!--                                <p>-->
<!--                                    <span style="color:#f62459">-->
<!--                                        Aproveite <strong>todos os benefícios</strong> da Allianz!-->
<!--                                    </span>-->
<!--                                </p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <figure>-->
<!--                        <img-->
<!--                            src="/assets/images/banner-home-allianz-02.png"-->
<!--                            alt="side-banner"-->
<!--                            title="side-banner"-->
<!--                        />-->
<!--                    </figure>-->
<!--                </div>-->
<!--            </div>-->

<!--&lt;!&ndash;            <div ngxSlickItem class="slide">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="know-more-content is-other is-background" style='background-image: url("/assets/images/banner-home-allianz.png");'>&ndash;&gt;-->
<!--&lt;!&ndash;                    <div class='know-wrapper-image'>&ndash;&gt;-->
<!--&lt;!&ndash;                        <figure>&ndash;&gt;-->
<!--&lt;!&ndash;                            <img&ndash;&gt;-->
<!--&lt;!&ndash;                                src="/assets/images/promocao-allianz.png"&ndash;&gt;-->
<!--&lt;!&ndash;                                alt="promocao"&ndash;&gt;-->
<!--&lt;!&ndash;                                title="promocao"&ndash;&gt;-->
<!--&lt;!&ndash;                            />&ndash;&gt;-->
<!--&lt;!&ndash;                        </figure>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    <div class="know-more-wrapper">&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class='text-area'>&ndash;&gt;-->
<!--&lt;!&ndash;                            <div class="text-description">&ndash;&gt;-->
<!--&lt;!&ndash;                                <p>&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span style='color: #FAB600;'>e mais...</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                </p>&ndash;&gt;-->
<!--&lt;!&ndash;                                <p>&ndash;&gt;-->
<!--&lt;!&ndash;                                    Ao contratar um Seguro Allianz você ainda concorre à <span style='color: #FAB600;'>Shows no Allianz Parque!</span> Quanto mais apólices participantes você tiver, mais chances você tem de<span style='color: #FAB600;'> ganhar!</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                </p>&ndash;&gt;-->
<!--&lt;!&ndash;                                <a href='https://boraproshow.allianz.com.br/taylor-swift' target='_blank' class="button">&ndash;&gt;-->
<!--&lt;!&ndash;                                    saiba mais&ndash;&gt;-->
<!--&lt;!&ndash;                                </a>&ndash;&gt;-->
<!--&lt;!&ndash;                            </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--        </ngx-slick-carousel>-->
<!--    </div>-->

    <div *ngFor="let component of data let i = index">
        <div *ngIf="component.handle === 'banners'">
            <div class="toggle-safes">
                <app-toggle-safe
                    [img]="component.data.image"
                    [altText]="component.data.alt_text"
                    [title]="component.data.image"
                    [idElement]="component.data.image"
                    [isEven]="component.image_direction == 'right' ? true : false"
                    [isOther]="true">
                    <div class="text-area">
                        <h1 *ngIf="component.data && component.data.text" class="text-title" [innerHTML]="component.data.text | htmlParse"></h1>
                        <p *ngIf="component.data && component.data.description" class="text-description" [innerHTML]="component.data.description | htmlParse"></p>
                        <p *ngIf="component.data && component.data.sub_description" class="text-subdescription" [innerHTML]="component.data.sub_description | htmlParse"></p>
                        <p style="font-size: 13px" class="pt-2">*Ranking Best Global Brands da Interbrand</p>
                    </div>
                    <!-- Newsletters -->
                    <article *ngIf="slug === '/' && (informationCard.title || informationCard.text)" class="information-card">
                        <h2
                            *ngIf="informationCard.title"
                            class="information-card__title"
                            [innerHTML]="informationCard.title | htmlParse"
                        ></h2>

                        <div
                            *ngIf="informationCard.text"
                            class="information-card__text"
                            [innerHTML]="informationCard.text | htmlParse"
                        ></div>
                    </article>
                    <!-- end Newsletters -->
                </app-toggle-safe>
            </div>
        </div>

        <div class="pt-5" *ngIf="component.handle === 'sections_tabbannersection'" [class.sections-with-information-card]="slug === '/'">
            <h2 class="title-tab" [innerHTML]="component.data.text | htmlParse"></h2>
            <app-tabs-rounded>
                <app-tab-rounded *ngFor="let tab of component.data.banners let i = index" [tabTitle]="tab.title" [active]="i == component.data.banners.length - 1">
                    <div >
                        <app-tab-description [tab]="tab"></app-tab-description>
                    </div>
                </app-tab-rounded>
            </app-tabs-rounded>
        </div>

        <!-- blog posts -->
        <section *ngIf="component.handle === 'knowledge_section'"
            class="blog-section"
            [id]="component.fragment || null"
            [style.background-color]="component.data.background_color || '#ffffff'"
        >
            <div class="wrapper-container">
                <h2
                    class="blog-section__title"
                    [innerHTML]="component.data.text | htmlParse"
                ></h2>

                <h3
                    *ngIf="component.data.description"
                    class="blog-section__subtitle"
                    [innerHTML]="component.data.description | htmlParse"
                ></h3>

                <div
                    *ngIf="component.data.articles?.length"
                    class="blog-cards"
                >
                    <article
                        class="blog-card"
                        *ngFor="let article of component.data.articles"
                    >
                        <a
                            *ngIf="article.link_url"
                            class="blog-card__image-link"
                            [href]="article.link_url"
                            [target]="article.link_external ? '_blank' : '_self'"
                            [attr.rel]="
                                article.link_external
                                    ? 'noopener noreferrer'
                                    : null
                            "
                        >
                            <img
                                class="blog-card__image"
                                [src]="article.image || article.link_image"
                                [alt]="article.alt_text || 'Imagem do artigo'"
                                loading="lazy"
                            >
                        </a>

                        <img
                            *ngIf="!article.link_url"
                            class="blog-card__image"
                            [src]="article.image || article.link_image"
                            [alt]="article.alt_text || 'Imagem do artigo'"
                            loading="lazy"
                        >

                        <div class="blog-card__content">
                            <h3
                                class="blog-card__label"
                                [innerHTML]="article.text | htmlParse"
                            ></h3>

                            <div
                                class="blog-card__text"
                                [innerHTML]="article.description | htmlParse"
                            ></div>

                            <a
                                *ngIf="article.link_url"
                                class="blog-card__link"
                                [href]="article.link_url"
                                [target]="article.link_external ? '_blank' : '_self'"
                                [attr.rel]="
                                    article.link_external
                                        ? 'noopener noreferrer'
                                        : null
                                "
                            >
                                <svg
                                    class="blog-card__arrow"
                                    width="24"
                                    height="11"
                                    viewBox="0 0 24 11"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M1 5.5L22.8694 5.5M18.6758 10L23 5.5L18.6758 1"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                                {{ article.link_text || 'Ler artigo completo' }}
                            </a>
                        </div>
                    </article>
                </div>
            </div>
        </section>
        <!-- end blog posts -->

         <!-- FAQ -->
        <section *ngIf="component.handle === 'faq_section'"
            class="faq-section"
            [id]="component.fragment || null"
            [style.background-color]="component.data.background_color || '#ffffff'"
        >
            <div class="wrapper-container faq-section__container">
                <h2
                    class="faq-section__title"
                    [innerHTML]="component.data.text | htmlParse"
                ></h2>

                <div
                    *ngIf="component.data.description"
                    class="faq-section__subtitle"
                    [innerHTML]="component.data.description | htmlParse"
                ></div>

                <div
                    *ngIf="component.data.items?.length"
                    class="faq-list"
                >
                    <article
                        class="faq-item"
                        *ngFor="let item of component.data.items; let faqIndex = index"
                        [class.faq-item--active]="activeFaqIndex === faqIndex"
                    >
                        <button
                            type="button"
                            class="faq-item__button"
                            (click)="toggleFaq(faqIndex)"
                            [attr.aria-expanded]="activeFaqIndex === faqIndex"
                            [attr.aria-controls]="'faq-answer-' + faqIndex"
                        >
                            <span [innerHTML]="item.question | htmlParse"></span>

                            <svg
                                class="faq-item__arrow"
                                width="18"
                                height="10"
                                viewBox="0 0 18 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                            >
                                <path
                                    d="M1 1L9 9L17 1"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </button>

                        <div
                            *ngIf="activeFaqIndex === faqIndex"
                            class="faq-item__answer"
                            [id]="'faq-answer-' + faqIndex"
                        >
                            <div [innerHTML]="item.answer | htmlParse"></div>
                        </div>
                    </article>
                </div>
            </div>
        </section>
        <!-- end FAQ -->

        <!-- <div *ngIf="component.handle === 'content_section'">
            <app-olimpycs></app-olimpycs>
        </div> -->

        <div class="avanti-palestra light-gray-bg-xp" *ngIf="component.handle === 'content_section'">
            <div class="avanti-palestra-texts">
                <div class="avanti-palestra-texts-title" [innerHTML]="component.text | htmlParse"></div>
                <div style="max-width: 475px;" [innerHTML]="component.description | htmlParse"></div>
            </div>
        </div>
    </div>
</div>
